<template>
  <div style="background-color: white">
    <div v-if="showPage" id="container">
      <dialog v-if="deletionObject" id="delete-modal">
        <svg @click="closeModal('delete-modal')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <h2>Delete Application</h2>
        <div class="delete-modal-box card-band-styling">
          To confirm deletion type out: "<strong>{{ deletionObject.title }}</strong>"
          <div style="text-align: center;">
            <input type="text" id="input-delete-modal-confirmation" :placeholder="deletionObject.title">
            <button @click="confirmDeletion(deletionObject)">Confirm Deletion</button>
          </div>
        </div>
      </dialog>
      <div class="function-buttons">
        <h2>My Apps</h2>
        <button class="primary-button-sm-global" @click="newApp" style="display: flex; justify-content: center; align-items: center;">
          New Application
        </button>
      </div>
      <div class="cards-format">
        <div class="activities-grid-resume">
          <article v-for="(app, index) in applicationList" :key="index">
            <div class="resume-activity-container">
              <div>
                <img v-if="app.image" :src="`${reverseProxy}/api/${app.image}`" alt="Picture N/A" loading="lazy"/>
              </div>
              <div style="margin-top: 5px;">
                <span v-if="app.published" class="badge-success-lg-global">Published</span>
                <span v-else class="badge-gray-lg-global">Draft</span>
                <h5>{{ app.title }}</h5>
                <p>{{ `${getCurrencySymbol(app.currency_code)}${app.single_unit_pricing}` }}</p>
                <div class="icons-grid">
                  <span @click="editApp(app)">
                    <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 19.9004H19" stroke="#494949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M5 15.9004V11.9004L15 1.90039L19 5.90039L9 15.9004H5Z" stroke="#494949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 4.90039L16 8.90039" stroke="#494949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Edit
                  </span>
                  <span @click="showPreviewModal(app)">
                    <svg viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 4.90039C11.7956 4.90039 12.5587 5.21646 13.1213 5.77907C13.6839 6.34168 14 7.10474 14 7.90039C14 8.69604 13.6839 9.4591 13.1213 10.0217C12.5587 10.5843 11.7956 10.9004 11 10.9004C10.2044 10.9004 9.44129 10.5843 8.87868 10.0217C8.31607 9.4591 8 8.69604 8 7.90039C8 7.10474 8.31607 6.34168 8.87868 5.77907C9.44129 5.21646 10.2044 4.90039 11 4.90039ZM11 0.400391C16 0.400391 20.27 3.51039 22 7.90039C20.27 12.2904 16 15.4004 11 15.4004C6 15.4004 1.73 12.2904 0 7.90039C1.73 3.51039 6 0.400391 11 0.400391ZM2.18 7.90039C2.98825 9.5507 4.24331 10.9411 5.80248 11.9136C7.36165 12.8862 9.1624 13.4017 11 13.4017C12.8376 13.4017 14.6383 12.8862 16.1975 11.9136C17.7567 10.9411 19.0117 9.5507 19.82 7.90039C19.0117 6.25008 17.7567 4.85964 16.1975 3.88714C14.6383 2.91463 12.8376 2.39907 11 2.39907C9.1624 2.39907 7.36165 2.91463 5.80248 3.88714C4.24331 4.85964 2.98825 6.25008 2.18 7.90039Z" fill="#494949"/>
                    </svg>
                    Preview
                  </span>
                  <span @click="deleteApp(app)">
                    <svg viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 16.9004C1 17.4308 1.21071 17.9395 1.58579 18.3146C1.96086 18.6897 2.46957 18.9004 3 18.9004H11C11.5304 18.9004 12.0391 18.6897 12.4142 18.3146C12.7893 17.9395 13 17.4308 13 16.9004V4.90039H1V16.9004ZM3 6.90039H11V16.9004H3V6.90039ZM10.5 1.90039L9.5 0.900391H4.5L3.5 1.90039H0V3.90039H14V1.90039H10.5Z" fill="#494949"/>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script> 
  import instance from '../axios.js'; 

  export default {
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        showPage: null,
        showChildView: false,
        params: null,
        applicationList: null,
        categorization: null,
        maxAgeRange: 100,
        inputObject: {
          search_query: '',
          startAgeValue: 'All',
          endAgeValue: 'All',
          classification: 'All',
          area: 'All',
          type: 'All',
          category: 'All',
          sub_category: 'All',
          periodStart: '',
          periodEnd: ''
        },
        deletionObject: null,
        previewArray: null,
        previewArrayIndex: 0
      }
    },
    async created() {
      try {
        this.assignFilteringValues();
        let response = await instance.get('/api/appAdmin/searchfilter', {
          params: {
            ...this.params,
            owner_uuid: this.$store.getters.getCurrentUser
          }
        });
        this.applicationList = response.data;
        let userCategorizationResponse = await instance.get(`/api/appAdmin/categorization/owner/${this.$store.getters.getCurrentUser}`);
        this.categorization = userCategorizationResponse.data;
        if (this.applicationList != null && this.applicationList.length > 0) {
          this.deletionObject = this.applicationList[0];
        }
        this.showPage = true;
      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      navButtons(direction) {
        if (direction == 'backward') {
          if (this.previewArrayIndex-1 >= 0) {
            this.previewArrayIndex -= 1;
          }
        } else if (direction == 'forward') {
          if (this.previewArrayIndex+1 < this.previewArray.length) {
            this.previewArrayIndex += 1;
          }
        }
      },
      formatTime(totalSeconds) {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      },
      formatForNewResolution(elementID) {
        this.$nextTick(() => {
          this.previewArray.forEach(question => {
            let currentQuestionInstance = question;
            let [originalWidth, originalHeight] = currentQuestionInstance.child_view_original_screen_resolution.split('x').map(Number);

            let newWidth = document.getElementById(elementID).offsetWidth;
            let newHeight = document.getElementById(elementID).offsetHeight;
            if (newWidth == originalWidth && newHeight == originalHeight) {
              return;
            }

            //[x,y] transform coordinates from original to new resolution
            let xTransform = newWidth / originalWidth;
            let yTransform = newHeight / originalHeight;

            for (let i = 0; i < currentQuestionInstance.child_buttons.length; i++) {
              currentQuestionInstance.child_buttons[i].x *= xTransform;
              currentQuestionInstance.child_buttons[i].y *= yTransform;
              currentQuestionInstance.child_buttons[i].height *= yTransform;
              currentQuestionInstance.child_buttons[i].width *= xTransform;
            }

            for (let i = 0; i < currentQuestionInstance.child_images.length; i++) {
              currentQuestionInstance.child_images[i].x *= xTransform;
              currentQuestionInstance.child_images[i].y *= yTransform;
              currentQuestionInstance.child_images[i].height *= yTransform;
              currentQuestionInstance.child_images[i].width *= xTransform;
            }

            currentQuestionInstance.child_view_original_screen_resolution = `${newWidth}x${newHeight}`;
          })
        });
      },
      getImageFileSrc(fileObject) {
        if (fileObject != null) {
          return URL.createObjectURL(fileObject);
        }
        return null;
      },
      openModal(id) {
        document.getElementById(id).showModal();
      },
      closeModal(id) {
        document.getElementById(id).close();
      },
      async showPreviewModal(app) {
        this.$router.push({
          path: `/appTester/${app.application_id}`
        })
      },
      assignFilteringValues() {
        this.params = this.getQueryParams();
        //parse query so search/filter can be used again with auto filled current data
        for (let key in this.params) {
          if (Object.hasOwnProperty.call(this.inputObject, key)) {
            this.inputObject[key] = this.params[key];
          }
          else if (key == 'age_group') {
            let ages = this.params['age_group'].split(',');
            this.inputObject.startAgeValue = ages[0];
            this.inputObject.endAgeValue = ages[1];
          }
          else if (key == 'created') {
            let dates = this.params['created'].split(',');
            this.inputObject.periodStart = dates[0] == 'All' ? '' : dates[0];
            this.inputObject.periodEnd = dates[1] == 'All' ? '' : dates[1];
          }
        }
      },
      changeStartDate() {
        let from = document.getElementById('startDate');
        let to = document.getElementById('endDate');
        if (from.value >= to.value && to.value !== '') {
          let temp = new Date(from.value);
          temp.setDate(temp.getDate());
          to.valueAsDate = temp;
        }
        to.min = from.value;
      },
      changeStartAgeRange() {
        let from = document.getElementById('startAge');
        let to = document.getElementById('endAge');
        if (from.value != 'All' && to.value != 'All') {
          if (parseInt(from.value) > parseInt(to.value)) {
            this.inputObject.endAgeValue = this.maxAgeRange;
          }
        }
      },
      getQueryParams() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const params = {};
        for (const [key, value] of urlParams.entries()) {
          params[key] = value;
        }
        return params;
      },
      newApp() {
        this.$router.push(`/rolesPage/SearchAppAdminApps/viewAppAdminApps/newAppCard`);
      },
      deleteApp(app) {
        this.deletionObject = app;
        this.openModal('delete-modal');
      },
      async confirmDeletion(app) {
        try {
          let confirmationString = document.getElementById("input-delete-modal-confirmation").value;
          if (app.title == confirmationString) {
            await instance.delete(`/api/appAdmin/${app.application_id}`);
            document.getElementById("input-delete-modal-confirmation").value = "";
            
            this.closeModal('delete-modal');
            let response = await instance.get('/api/appAdmin/searchfilter', {
              params: this.params
            });
            this.applicationList = response.data;
          }
          else {
            alert("confirmation string does not match")
          }
        } catch (e) {
          console.error(e);
        }
      },
      cloneApp(application_id) {
        this.$router.push({
          path: `/rolesPage/SearchAppAdminApps/viewAppAdminApps/cloneAppName`,
          query: {
            application_id
          }
        })
      },
      async newFilters() {
        try {
          let ageRangeResult = '';
          ageRangeResult += this.inputObject.startAgeValue;
          ageRangeResult += ',';
          ageRangeResult += this.inputObject.endAgeValue;

          let periodRangeResult = '';
          periodRangeResult += this.inputObject.periodStart == '' ? 'All' : this.inputObject.periodStart;
          periodRangeResult += ',';
          periodRangeResult += this.inputObject.periodEnd == '' ? 'All' : this.inputObject.periodEnd;

          const currentRoute = this.$route;
          const targetQuery = {
            ...(this.inputObject.search_query == '' ? {} : {search_query: this.inputObject.search_query}),
            ...(ageRangeResult == 'All,All' ? {} : {age_group: ageRangeResult}),
            ...(this.inputObject.classification == 'All' ? {} : {classification: this.inputObject.classification}),
            ...(this.inputObject.area == 'All' ? {} : {area: this.inputObject.area}),
            ...(this.inputObject.type == 'All' ? {} : {type: this.inputObject.type}),
            ...(this.inputObject.category == 'All' ? {} : {category: this.inputObject.category}),
            ...(this.inputObject.sub_category == 'All' ? {} : {sub_category: this.inputObject.sub_category}),
            ...(periodRangeResult == 'All,All' ? {} : {created: periodRangeResult})
          };
          const currentKeys = Object.keys(currentRoute.query);
          const targetKeys = Object.keys(targetQuery);
          const isSameKeys = currentKeys.length === targetKeys.length && currentKeys.every(key => targetKeys.includes(key));
          const isDifferentQuery = !isSameKeys || !currentKeys.every(key =>
            currentRoute.query[key] === targetQuery[key]
          );

          if (isDifferentQuery) {
            this.$router.replace({ query: targetQuery });
            this.assignFilteringValues();
            let response = await instance.get('/api/appAdmin/searchfilter', {
              params: {
                ...this.params,
                owner_uuid: this.$store.getters.getCurrentUser
              }
            });
            this.applicationList = response.data;
          }

        } catch (e) {
          console.error(e);
        }
      },
      editApp(app) {
        this.$router.push(`/rolesPage/SearchAppAdminApps/viewAppAdminApps/newAppCard/${app.application_id}`);
      },
      getCurrencySymbol(currencyCode) {
        const currencyMap = {
            USD: "$",
            EUR: "€",
            GBP: "£",
            JPY: "¥",
            CNY: "¥",
            RUB: "₽"
        };
        return currencyMap[currencyCode] || "";
      },
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  #container {
    position: relative;

    padding: 1rem;
  }

  .cards-format {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;

    .activities-grid-resume {
      width: 100%;
      display: flex;
      column-gap: 2rem;

      article {
        box-shadow: 0px 4px 4.7px 0px #0000000D;
        border-radius: 10px;
        border: solid 1px globalSharedVariables.$grey-200;
        padding: 1rem;

        .resume-activity-container {
          display: grid;
          grid-template-rows: 145px 200px;
          grid-template-columns: 313px;

          h5, p {
            margin: 0;
          }

          p {
            color: globalSharedVariables.$grey-700;
            font-size: 2rem;
          }

          > div:nth-child(2) {
            display: grid;
            grid-template-rows: 45px 30px 45px;

            .icons-grid {
              display: flex;
              align-self: center;
              
              span {
                margin: 0 1rem 0 0;
                user-select: none;
                cursor: pointer;

                &:hover {
                  color: #B08225;

                  svg path {
                    stroke: #B08225;
                    fill: #B08225;
                  }
                }
              }
            }

/*             > * {
              margin: 0;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 1.5em;
              max-height: calc(1.5em * 2);
            } */
          }

          img {
            border-radius: 5px;
            width: 100%;
            height: 100%;
          }

          svg {
            width: 22px;
            height: 22px;
          }
        }
      }
    }
  }

  .function-buttons {
    display: flex;
    justify-content: space-between;
    padding: .25rem;
    border-radius: 50rem;
    top: globalSharedVariables.$navbar-height;

    button {
      width: 200px;
      font-size: 1rem;
    }
  }

  .input-table {
    border-spacing: 0;
    border-collapse: separate;
    
    tbody {
      margin-top: 10px;
    }

    tr > td:first-child {
      text-align: right;
    }

    input[type="date"], .ageGroup {
      width: fit-content;
      padding: 0 1rem;
      cursor: pointer;
    }

    td, th {
      padding: 5px;
    }

    th {
      text-align: center;
      width: 100%;
    }
  }

  .tooltip-searchDate {
    position: relative;
    display: inline-block;

    .tooltiptext-searchDate {
      display: none;
      width: fit-content;
      background-color: white;
      text-align: center;
      border-radius: 6px;
      padding: 5px;
      position: absolute;
      z-index: 1;
      bottom: 150%;
      left: 50%;
      transform: translateX(-100%);
      font-size: .8rem;
      font-weight: 400;
    }

    &:hover .tooltiptext-searchDate {
      display: block;
    }

    .tooltip-table {
      td {
        border: solid black 1px;
      }
    }
  }
</style>